module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.brandZones.length) ? _c('tr', [_c('th', {
    staticClass: "selectors pl-0",
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('ClientColorButton', {
    attrs: {
      "size": 's',
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.selectAll()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.selectAll")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('ClientColorButton', {
    attrs: {
      "size": 's',
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.selectNone()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.selectNone")))])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('tbody', _vm._l((_vm.brandZones), function(brandZone) {
    return _c('tr', {
      key: brandZone.zone.id
    }, [_c('td', [_c('label', {
      staticClass: "label-checkbox pointer mb-0 d-flex align-items-center justify-content-center",
      attrs: {
        "for": 'checkbox_zone_' + brandZone.zone.id
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.checkedZones.includes(brandZone.zone.id)),
        expression: "checkedZones.includes(brandZone.zone.id)"
      }],
      staticClass: "rem3rch-checkbox rem3rch-checkbox",
      on: {
        "click": function($event) {
          _vm.checkZone(brandZone.zone.id, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), (!_vm.checkedZones.includes(brandZone.zone.id)) ? _c('span', {
      staticClass: "rem3rch-checkbox rem3rch-checkbox",
      on: {
        "click": function($event) {
          _vm.checkZone(brandZone.zone.id, true)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "id"
    }, [_vm._v(_vm._s(brandZone.zone.id))]), _vm._v(" "), _c('td', {
      staticClass: "refClient"
    }, [_vm._v(_vm._s(brandZone.zone.refClient))]), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(brandZone.zone.name))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da06b2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zoneGroups/ZoneGroupsTable.vue
// module id = 3290
// module chunks = 0